/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react/sort-comp */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import {
  MainContainer, Paragraph, Image, Button,
} from './StyledComponents';
import base64conversion from '../services/base64conversion';
import logo from '../images/icon-192x192.png';
import profile from '../images/profile.png';
import { getBrowser } from '../services/browser';
import formatDate from '../services/formatDate';
import back from '../images/back (1).svg';
import loader from '../images/loading.gif';
import { getSchoolData, isGoogleLoginSchool } from '../services/getSchoolHostname';
import GetSchoolName from '../View/GetSchoolName';

export default class StudentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studentDetails: [],
      qrCodeValue: [],
      date: formatDate(new Date()),
      defferedPrompt: null,
      showAndroidModal: false,
      showiOSModal: false,
      loading: false,
      // isStudentInActive: false,
      showPopup: true,
      loggingOut: false,
      errorMsg: '',
      showToastErrorMsg: false,
    };
    this.getSuffix = this.getSuffix.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  async componentDidMount() {
    // Installing Pop Up
    const { prompt } = this.props;
    this.setState({ defferedPrompt: prompt });
    // timer
    this.intervalId = setInterval(() => this.tick(), 1000);
    // Getting details of student and redirecting request accordingly
    const studentDetails = JSON.parse(localStorage.getItem('studentDetails'));
    const getTodaysDate = localStorage.getItem('todaysDate');
    const currentDt = new Date();
    let currMonth = currentDt.getMonth() + 1;
    if (currMonth < 10) currMonth = `0${currMonth}`;
    let currDate = currentDt.getDate();
    if (currDate < 10) currDate = `0${currDate}`;
    const current = `${currentDt.getFullYear()}-${currMonth}-${currDate}`;
    const header = base64conversion();

    if (current === getTodaysDate && studentDetails) {
      this.setState({
        loading: false,
        studentDetails,
        qrCodeValue: studentDetails.show_id,
      });
    }
    if (studentDetails) {
      if (current !== getTodaysDate) {
        this.setState({
          loading: true,
        });
      }
      this.setState({
        studentDetails,
        qrCodeValue: studentDetails.show_id,
      });
      const objToBeSent = {
        school_code: studentDetails.school_code,
        student_id: studentDetails.student_id,
        student_no: studentDetails.student_no,
      };
      fetch(`${process.env.REACT_APP_API_HEAD}/checkStudentIsActive`, {
        method: 'POST',
        body: JSON.stringify(objToBeSent),
        headers: {
          'Content-Type': 'application/json',
          Authorization: header,
        },
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.status === 200) {
            localStorage.setItem('todaysDate', current);
            if (res.data.isStudentActive !== 'yes') {
              this.setState({
                loading: false,
                // isStudentInActive: true,
              });
              localStorage.setItem('isStudentInActive', true);
            } else {
              this.setState({
                loading: false,
                // isStudentInActive: false,
              });
              localStorage.setItem('isStudentInActive', false);
            }
          } else {
            this.setState({
              loading: false,
            });
            localStorage.setItem('isStudentInActive', false);
          }
        })
        .catch((error) => {
          //  // console.log(error);
          this.setState({
            loading: false,
          });
          localStorage.setItem('isStudentInActive', false);
        });
    } else {
      const { history } = this.props;
      history.push('/');
    }
  }

  tick() {
    this.setState({ date: formatDate(new Date()) });
  }

  getSuffix() {
    const { studentDetails } = this.state;
    const j = studentDetails.grade % 10;
    const k = studentDetails.grade % 100;
    if (j === 1 && k !== 11) {
      return `${studentDetails.grade}st`;
    }
    if (j === 2 && k !== 12) {
      return `${studentDetails.grade}nd`;
    }
    if (j === 3 && k !== 13) {
      return `${studentDetails.grade}rd`;
    }
    return `${studentDetails.grade}th`;
  }

  handleLogout() {
    this.setState({
      loggingOut: true,
    });
    const header = base64conversion();
    const { studentDetails } = this.state;

    const objToBeSent = {
      school_code: studentDetails.school_code,
      student_id: studentDetails.student_id,
      student_no: studentDetails.student_no,
    };

    fetch(`${process.env.REACT_APP_API_HEAD}/digitalidLogout`, {
      method: 'POST',
      body: JSON.stringify(objToBeSent),
      headers: {
        'Content-Type': 'application/json',
        Authorization: header,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status === 200) {
          localStorage.clear();
          window.location.href = '/';
          this.setState({
            loggingOut: false,
          });
        } else {
          this.setState({
            loggingOut: false,
            errorMsg: res.message,
            showToastErrorMsg: true,
          });
          setTimeout(() => this.setState({ showToastErrorMsg: false }), 3000);
        }
      })
      .catch((error) => {
        //  // console.log(error);
        this.setState({
          loggingOut: false,
          errorMsg: 'Something went wrong, Please try again!',
          showToastErrorMsg: true,
        });
        setTimeout(() => this.setState({ showToastErrorMsg: false }), 3000);
      });
  }

  render() {
    //  // console.log(this.state.defferedPrompt) shows null
    const {
      studentDetails,
      date,
      qrCodeValue,
      defferedPrompt,
      showAndroidModal,
      showiOSModal,
      loading,
      // isStudentInActive,
      loggingOut,
      showToastErrorMsg,
      showPopup,
      errorMsg,
    } = this.state;

    const { history } = this.props;
    const browser = getBrowser();

    const isStudentInActiveLocal = localStorage.getItem('isStudentInActive');
    const [base64Img, qrCodeColor] = getSchoolData();
    const schoolHasGoogleLogin = isGoogleLoginSchool();

    if (loading) {
      return (
        <img className="menu-loader" src={loader} alt="Loading ..." />
      );
    }

    if (isStudentInActiveLocal === 'true') {
      history.push({
        pathname: '/noAccess',
        state: {
          isStudentInActive: true,
        },
      });
      return 0;
    }

    if (
      (studentDetails.student_photo_url === '' || studentDetails.student_photo_url === ' ')
      && isStudentInActiveLocal === 'false'
    ) {
      history.push({
        pathname: '/noAccess',
        state: {
          isStudentInActive: false,
        },
      });
      return 0;
    }

    return (
      <MainContainer className="student-detail-page">
        {(showPopup && !window.matchMedia('(display-mode: standalone)').matches) ? (
          <div className="backdrop-box">
            <div className="installModal">
              <div className="installHeader">
                <div id="heading">Install Digital ID</div>
                <div
                  id="closeButton"
                  onClick={() => this.setState({ showPopup: false })}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      this.setState({ showPopup: false });
                    }
                  }}
                  role="button"
                  tabIndex={0}
                >
                x
                </div>
                {/* // `"` can be escaped with `&quot;`, `&ldquo;`, `&#34;`, `&rdquo;`. */}
              </div>
              <div className="installBody">
                <p>
              Ensure to install your digital ID to your device.
              See instructions by clicking on the
                  <br />
                  &quot; + &quot;
                  <br />
              sign in the middle to the right of the ID.
                </p>
                <div
                  id="closeButton"
                  className="popup-btn"
                  onClick={() => this.setState({ showPopup: false })}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      this.setState({ showPopup: false });
                    }
                  }}
                  role="button"
                  tabIndex={0}
                >
                Ok
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {showAndroidModal ? (
          <div className="backdrop-box">
            <div className="installModal">
              <div className="installHeader">
                <div id="heading">Steps to Install</div>
                <div
                  id="closeButton"
                  onClick={() => this.setState({ showAndroidModal: false })}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      this.setState({ showAndroidModal: false });
                    }
                  }}
                  role="button"
                  tabIndex={0}
                >
                x
                </div>
              </div>
              <div className="installBody">
                <ol className="list">
                  <li>
                  Tap the
                    <strong> menu </strong>
                  button on the top of your screen.
                    {' '}
                  </li>
                  <li>
                  From the options tap the
                    <strong> Add to Homescreen </strong>
                    {' '}
                  option.
                  </li>
                  <li>
                  Tap
                    <strong> Add </strong>
                    {' '}
                  in the alert.
                  </li>
                </ol>
                <div
                  id="closeButton"
                  className="popup-btn"
                  onClick={() => this.setState({ showAndroidModal: false })}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      this.setState({ showAndroidModal: false });
                    }
                  }}
                  role="button"
                  tabIndex={0}
                >
                Ok
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {showiOSModal ? (
          <div className="backdrop-box">
            <div className="installModal">
              <div className="installHeader">
                <div id="heading">Steps to Install</div>
                <div
                  id="closeButton"
                  onClick={() => this.setState({ showiOSModal: false })}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      this.setState({ showiOSModal: false });
                    }
                  }}
                  role="button"
                  tabIndex={0}
                >
                x
                </div>
              </div>
              <div className="installBody">
                <ol className="list">
                  <li>
                Tap the
                    {' '}
                    <strong>Share</strong>
                    {' '}
                  button on the bottom of your screen.
                  </li>
                  <li>
                  From the options tap the
                    <strong> Add to Homescreen </strong>
                    {' '}
                  option.
                  </li>
                  <li>Wait for the Logo to load.</li>
                  <li>
                  Tap
                    <strong> Add </strong>
                    {' '}
                  in the upper-right corner.
                  </li>
                </ol>
                <div
                  id="closeButton"
                  className="popup-btn"
                  onClick={() => this.setState({ showiOSModal: false })}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      this.setState({ showiOSModal: false });
                    }
                  }}
                  role="button"
                  tabIndex={0}
                >
                Ok
                </div>
              </div>
            </div>
          </div>
        ) : null}

        <header>
          {(schoolHasGoogleLogin) ? (
            <button
              type="button"
              className="logout-btn"
              tabIndex={0}
              onKeyPress={() => {}}
              onClick={this.handleLogout}
              disabled={loggingOut}
              style={loggingOut ? { cursor: 'not-allowed' } : { cursor: 'pointer' }}
            >
              {loggingOut
                ? (
                  <span>
                    <i className="fa fa-spinner spin" aria-hidden="true" />
                  </span>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span>
                      <i
                        className="fa fa-power-off"
                        title="Logout"
                        aria-hidden="true"
                      />
                    </span>
                    <span style={{ fontSize: '12px' }}>Logout</span>
                  </div>
                )}
            </button>
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                position: 'absolute',
                zIndex: '10',
                marginLeft: '20px',
              }}
              onClick={() => {
                history.push('/studentDetails');
              }}
              role="button"
            >
              <Image
                alt="Back"
                style={{ width: '22px', marginTop: '20px' }}
                src={back}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = logo;
                }}
              />
            </div>
          )}
          <Paragraph className="school-name">
            {studentDetails.school_name && (
              <GetSchoolName schoolName={studentDetails.school_name} />
            )}
          </Paragraph>
          {
            (schoolHasGoogleLogin) ? (
              <div
                role="button"
                className="options-btn"
                tabIndex={0}
                onKeyPress={() => {}}
              >
                <span>
                  <i className="fa fa-ellipsis-h" aria-hidden="true" />
                </span>
              </div>
            ) : null
          }
        </header>
        {showToastErrorMsg ? (
          <div className="logout-error">
            <p>{errorMsg}</p>
          </div>
        ) : null}
        <div className="student-photo-wrapper">
          <div className="student-photo">
            <Image
              alt="Student"
              src={studentDetails.student_photo_url || profile}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = profile;
              }}
              className="student-img"
            />
          </div>
          <div className="school-logo">
            <Image
              alt="School Logo"
              src={studentDetails.school_logo || logo}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = logo;
              }}
              className="school-img"
            />
          </div>
        </div>
        {defferedPrompt ? (
          <Button
            className="add-app"
            onClick={() => {
              defferedPrompt.prompt();
              this.setState({ defferedPrompt: null });
            }}
          >
            +
          </Button>
        ) : browser === 'Android'
          && !window.matchMedia('(display-mode: standalone)').matches
          && localStorage.getItem('StepsClicked') !== 'true' ? (
            <Button
              className="add-app"
              onClick={() => {
                this.setState({ showAndroidModal: true });
              }}
            >
            +
            </Button>
          ) : browser === 'iOS'
          && !window.navigator.standalone
          && localStorage.getItem('StepsClicked') !== 'true' ? (
            <Button
              className="add-app"
              onClick={() => {
                this.setState({ showiOSModal: true });
              }}
            >
            +
            </Button>
            ) : null}
        <div className="studentDetailsWrapper">
          <Paragraph className="stu-name">
            {studentDetails.first_name}
            {' '}
            {studentDetails.last_name}
          </Paragraph>
          <Paragraph className="stu-grade">
            {this.getSuffix()}
            {' '}
          Grade
          </Paragraph>
          {studentDetails.lpass === 'Yes' && (
          <div className="lunchpass">
            <span>Lunch Pass</span>
          </div>
          )}
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignContent: 'center',
              justifyContent: 'center',
            }}
          >
            {date.map((element, i) => {
              if (date.length - 1 === i) {
                return (
                  <Paragraph className="time" key={i}>
                    {' '}
                    {element}
                  </Paragraph>
                );
              }
              return (
                <div style={{ display: 'flex', flexDirection: 'row' }} key={i}>
                  <Paragraph className="time">{element}</Paragraph>
                  <Paragraph className="time colored"> : </Paragraph>
                </div>
              );
            })}
          </div>
          <Paragraph className="stu-id">{studentDetails.show_id}</Paragraph>
        </div>
        <div className="footer-wrapper">
          <div className="qr-code">
            <QRCode
              fgColor={qrCodeColor}
              value={qrCodeValue.toString()}
              size={73}
              level="L"
            />
          </div>
          <footer className="stu-id-footer">
            <img src={base64Img} alt="round footer image" />
          </footer>
        </div>
      </MainContainer>
    );
  }
}
StudentDetails.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  prompt: PropTypes.object.isRequired,
};
